/* eslint-disable no-console */

export const Types = {
  REQUEST: '@user/REQUEST',
  SUCCESS: '@user/SUCCESS',
  UPDATE: '@user/UPDATE',
  LOGOUT: '@user/LOGOUT',
  FAILURE: '@user/FAILURE',
};

// async function saveNotificationsToken(user) {
//   try {
//     const response = await askForNotifications();
//     if (response?.token) {
//       usersApi.device(user.cpf, user.email, response?.token);
//     }
//   } catch (e) {
//     if (e?.code === 'messaging/permission-blocked') {
//       console.info('O usuário negou a permissão das notificações.');
//     } else {
//       console.info('Erro ao solicitar as notificações.', e?.code);
//     }
//   }
// }

export function loadUserRequest(
  onSuccess,
  onFailure,
  onFinally,
  isLoginRoute = false,
) {
  return {
    type: Types.REQUEST,
    meta: { onSuccess, onFailure, onFinally, isLoginRoute },
  };
}

export function loadUserSuccess(user) {
  // saveNotificationsToken(user);

  return {
    type: Types.SUCCESS,
    payload: user,
  };
}

export function updateUser(user) {
  return {
    type: Types.UPDATE,
    payload: user,
  };
}

export function logoutUser() {
  return {
    type: Types.LOGOUT,
  };
}

export function loadUserFailure(error) {
  return {
    type: Types.FAILURE,
    error,
  };
}
